var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcChevdowntiny(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "11px",
    height: "7px",
    viewBox: "0 0 11 7",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/ic-chev down tiny") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Components",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-44.000000, -203.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(40.000000, 197.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Background",
    transform: "translate(10.000000, 10.000000) scale(-1, -1) rotate(90.000000) translate(-10.000000, -10.000000) ",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7207063,7.00496903 C13.7275178,7.01159511 13.7342375,7.01831483 13.7408636,7.02512627 C14.1532482,7.44904618 14.1532482,8.12420557 13.7408636,8.54812549 L10.4073602,11.9748737 C10.1629504,12.2261201 9.82187988,12.3264763 9.50029155,12.2743404 C9.17882637,12.326684 8.83730261,12.2263802 8.59263983,11.9748737 L8.59263983,11.9748737 L5.25913644,8.54812549 C4.84675176,8.12420557 4.84675176,7.44904618 5.25913644,7.02512627 L5.25913644,7.02512627 L5.27929367,7.00496903 C5.68841436,6.60698088 6.34270535,6.61600558 6.7406935,7.02512627 L6.7406935,7.02512627 L9.49984793,9.86028292 L12.2593065,7.02512627 C12.6572947,6.61600558 13.3115856,6.60698088 13.7207063,7.00496903 Z",
    id: "Combined-Shape",
    fill: "#333333"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcChevdowntiny);
export default __webpack_public_path__ + "static/media/ic-chev down tiny.25c3ab28.svg";
export { ForwardRef as ReactComponent };